import { gql } from '@apollo/client';

export const ALL_ACTIVITY_TYPES = gql`
  query AllActivityTypes {
    activityTypes: getActivityTypes {
      id
      name
    }
  }
`;
